import React from 'react';
import { HStack, IconButton, Text, Tooltip } from '@chakra-ui/react';
import { InfoIcon } from './AdminIcon';

export const sessionDurationHelp = 'The session duration is the typical amount of time someone is visiting the space for this purpose. It is used to record their session end time if they forget to end their session when they leave.';

export default function SessionDurationLabel() {
  return <HStack as="span" spacing={1} display="inline-flex">
    <Text as="span">Session duration</Text>
    <Tooltip label={sessionDurationHelp} hasArrow placement="top" maxW="320px">
      <IconButton type="button" aria-label="About session duration" icon={<InfoIcon boxSize={4} />}
        variant="ghost" size="xs" onClick={event => event.stopPropagation()} />
    </Tooltip>
  </HStack>;
}
